import React from 'react';

/* Components */
import FlowRendererComponent from 'conversie-flow-bundle/assets/js/components/flow/renderers/FlowRendererComponent';
import ConversionFieldMoney from './fields/ConversionFieldMoney';

// /* Conversion Fields */
import ConversionFieldChoice from './fields/ConversionFieldChoice';
import ConversionFieldChoiceSalesforce from '../../conversion-flow/components/fields/ConversionFieldChoiceSalesforce';
import ConversionFieldSelect from './fields/ConversionFieldSelect';
import ConversionFieldChoiceSubscription from './fields/ConversionFieldChoiceSubscription';
import ConversionFieldChoicesSlider from "./fields/ConversionFieldChoicesSlider";

export default function ConversionFlowComponentRendererVDP({ flow, pricePerMonth, vehiclePrice, loading, id = 'form' }) {
    return (
        <FlowRendererComponent
            components={flow?.form?.components}
            path={`form.components`}
            id={`form-${flow?.flowId}.components`}
            renderComponent={(component, props) => {
                if (component.name === 'header') {
                    return (
                        <p className="flow__label mb-2 mb-xl-3">{component?.metadata?.title}</p>
                    )
                }
            }}
            renderField={(field, props) => {

                if(field.name === 'kilometrage' || field.name === 'duration') {
                    return (
                        <ConversionFieldChoicesSlider
                            {...props}
                            field={{
                                ...field,
                            }}
                        />
                    );
                }

                if (field.type === 'choice-radio' && field.view !== 'vdp-subscription' && field.name !== 'delivery-packages') {
                    return (
                        <ConversionFieldChoice
                            {...props}
                            field={{
                                ...field,
                            }}
                            pricePerMonth={pricePerMonth}
                            vehiclePrice={vehiclePrice}
                            customControlClassName="custom-control-vdp"
                            inputType="radio"
                        />
                    );
                }

                if (field.type === 'choice-radio' && (field.view === 'vdp-subscription' || field.name === 'delivery-packages')) {
                    return (
                        <ConversionFieldChoiceSubscription
                            {...props}
                            field={{
                                ...field,
                            }}
                            customControlClassName="custom-control-vdp"
                            inputType="checkbox"
                        />
                    );
                }

                if (field.type === 'money') {
                    return (
                        <ConversionFieldMoney
                            {...props}
                            vehiclePrice={vehiclePrice}
                            loading={loading}
                            field={{
                                ...field,
                            }}
                        />
                    );
                }

                if (field.type === 'choice-dropdown') {
                    return (
                        <ConversionFieldSelect
                            {...props}
                            field={{
                                ...field,
                            }}
                        />
                    );
                }

                if (field.type === 'salesforce-consent') {
                    return (
                        <ConversionFieldChoiceSalesforce
                            {...props}
                            formGroupClassName="form-group--flow-choice-grid"
                            customControlClassName="custom-control w-100"
                            inputType="checkbox"
                        />
                    );
                }
            }}
        />
    )
}
